import { render, staticRenderFns } from "./ModalGroupEdit.vue?vue&type=template&id=61ff9f99&scoped=true"
import script from "./ModalGroupEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupEdit.vue?vue&type=style&index=0&id=61ff9f99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff9f99",
  null
  
)

export default component.exports